import { cx } from "@linaria/core";
import type { ReactNode, Ref } from "react";
import React from "react";

import * as styles from "./styles/ContentBoundary";

type Props = {
  className?: string;
  children: React.ReactNode;

  ref?: Ref<HTMLDivElement | null>;
};

export function ContentBoundary({
  className,
  children,
  ref,
}: Props): ReactNode {
  return (
    <div ref={ref} className={cx(className, styles.boundaryCls)}>
      {children}
    </div>
  );
}
